import React from "react";
import ImageUploadField from "./ImageUploadField";

const emptyMethod = { name: "", qr: "" };
const SUGGESTIONS = ["FonePay", "eSewa", "Khalti", "ConnectIPS", "IME Pay", "Bank QR"];

/*
  Donation QR codes. Each entry = a display name + a QR image. On the public
  site's Donation card every entry becomes a button (FonePay / eSewa / ...);
  clicking one swaps the QR shown to the donor.
*/
export default function PoliticalPaymentsTab({ methods, setMethods, form, set, personaluid }) {
    const upd = (i, patch) => {
        const c = [...methods];
        c[i] = { ...c[i], ...patch };
        setMethods(c);
    };
    const removeAt = (i) => setMethods(methods.filter((_, idx) => idx !== i));
    const move = (i, dir) => {
        const j = i + dir;
        if (j < 0 || j >= methods.length) return;
        const c = [...methods];
        [c[i], c[j]] = [c[j], c[i]];
        setMethods(c);
    };

    return (
        <div>
            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold d-flex justify-content-between align-items-center">
                    <span>Donation QR Codes <small className="text-muted fw-normal">(up to 8)</small></span>
                    <button type="button" className="btn btn-sm btn-outline-primary" disabled={methods.length >= 8}
                        onClick={() => setMethods([...methods, { ...emptyMethod }])}>
                        <i className="bi bi-plus-lg me-1" />Add QR Code
                    </button>
                </div>
                <div className="card-body">
                    <p className="text-muted small">
                        Upload one QR image per payment method and give it a name. Visitors see a button for each one on your Contact section and the QR changes when they click it. The first one is shown by default.
                    </p>
                    {methods.length === 0 ? (
                        <p className="text-muted mb-0">No QR codes yet — donations stay hidden until you add at least one.</p>
                    ) : (
                        <div className="row g-3">
                            {methods.map((m, i) => (
                                <div className="col-md-6" key={i}>
                                    <div className="border rounded p-3 h-100">
                                        <label className="form-label small text-muted">Name (button label) *</label>
                                        <input className="form-control form-control-sm" list="pol-pay-suggest" maxLength={80} placeholder="e.g. eSewa" value={m.name} onChange={(e) => upd(i, { name: e.target.value })} />
                                        <label className="form-label small text-muted mt-2">QR image *</label>
                                        <ImageUploadField value={m.qr} onChange={(v) => upd(i, { qr: v })} purpose="logo" personaluid={personaluid} placeholder="Upload QR image" allowUrl={false} />
                                        {(!m.name.trim() || !m.qr) && <div className="small text-warning mt-2"><i className="bi bi-exclamation-triangle me-1" />Both a name and an image are needed or this entry won't be saved.</div>}
                                        <div className="d-flex gap-2 mt-3">
                                            <button type="button" className="btn btn-sm btn-outline-secondary" disabled={i === 0} onClick={() => move(i, -1)} aria-label="Move up"><i className="bi bi-arrow-up" /></button>
                                            <button type="button" className="btn btn-sm btn-outline-secondary" disabled={i === methods.length - 1} onClick={() => move(i, 1)} aria-label="Move down"><i className="bi bi-arrow-down" /></button>
                                            <button type="button" className="btn btn-sm btn-outline-danger ms-auto" onClick={() => removeAt(i)}><i className="bi bi-trash me-1" />Remove</button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    <datalist id="pol-pay-suggest">{SUGGESTIONS.map((s) => <option key={s} value={s} />)}</datalist>
                </div>
            </div>

            <div className="card shadow-sm mb-3">
                <div className="card-header bg-light fw-semibold">Donation Settings</div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-md-4">
                            <label className="form-label small">Minimum donation (NPR)</label>
                            <input type="number" min="10" className="form-control form-control-sm" value={form.min_donation ?? 100} onChange={(e) => set("min_donation", e.target.value)} />
                        </div>
                    </div>
                    <small className="form-text text-muted mt-2 d-block">Donors upload a payment screenshot; you verify each donation from the Inbox tab.</small>
                </div>
            </div>
        </div>
    );
}